<script setup lang="ts">
import { RemainingEstimateCourse } from '@/type/Course'
import { computed } from 'vue'

const prop = defineProps<Props>()

interface Props {
  course: RemainingEstimateCourse
}

const remaining_percent = computed(() => {
  if (!prop.course.get_estimate_remaining_price) {
    return 0
  }

  const percentage =
    (prop.course.get_estimate_remaining_price / prop.course.estimate_price) *
    100
  if (percentage > 100) {
    return 100
  }
  return percentage
})
</script>

<template>
  <div class="tw-mb-3">
    <van-cell
      center
      is-link
      @click="$emit('click', course)"
      class="tw-mb-3 !tw-p-4"
    >
      <template #title>
        <div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <img
              :src="course.icon_url"
              alt="course image"
              class="tw-w-8 tw-h-8 tw-rounded-xs"
            />
            <p>{{ course.course_name }}</p>
          </div>
          <div
            class="tw-w-full tw-items-center tw-gap-2 tw-text-xs tw-mt-3 tw-justify-between"
          >
            <!-- หลอดพลังแสดงค่า -->
            <div class="tw-w-full tw-text-right">
              <p class="tw-text-xs">
                {{ $t('course.total_estimate_price') }}:
                <span class="tw-text-base tw-text-bold">{{
                  course.estimate_price
                }}</span>
              </p>
            </div>
            <van-progress
              :percentage="remaining_percent"
              color="#07B53B"
              :show-pivot="false"
              stroke-width="8px"
            />
            <div class="tw-grid tw-grid-cols-2">
              <div class="tw-w-full tw-text-left">
                <div
                  class="tw-mt-2 tw-rounded-full tw-bg-gray-500 tw-w-2 tw-h-2"
                ></div>
                <p class="tw-text-xs">
                  {{ $t('course.used_estimate_price') }}:
                  <span class="tw-text-base tw-text-bold">{{
                    course.total_used_estimate_course_item_cost
                  }}</span>
                </p>
              </div>
              <div class="tw-w-full tw-text-left">
                <div
                  class="tw-mt-2 tw-rounded-full tw-bg-green-500 tw-w-2 tw-h-2"
                ></div>
                <p class="tw-text-xs">
                  {{ $t('course.remaining_estimate_price') }}:
                  <span class="tw-text-base tw-text-bold">{{
                    course.get_estimate_remaining_price
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </van-cell>
  </div>
</template>

<style scoped>
:deep(.van-cell) {
  padding: 16px;
  background: white;
  border-radius: 12px;
}

:deep(.van-cell__right-icon) {
  position: absolute;
  top: 16px;
  right: 16px;
}
</style>
